export const EMPTY_STORE_MESSAGE = 'In order to provide you with possible appointment times, please select the location you\'d like to bring your vehicle in to.'
export const DROP_OFF_TIMES = 'Drop-off Times'
export const AVAILABLE_TIME = 'Available Times'
export const SELECT_DATE_MESSAGE = 'Please select a date on the calendar to view available drop-off times.'
export const CALL_STORE_MESSAGE_PREFIX = 'Don\'t see a time that works? Call the store at '
export const CALL_STORE_MESSAGE_SUFFIX = ' for more options.'
export const TIME_SLOTS_ID = 'available-time-slots'
export const DISABLED_STATE_CALL_STORE_PREFIX = 'Call the store at '
export const DISABLED_STATE_CALL_STORE_SUFFIX = ' for available time options.'
export const EMPTY_CART_MESSAGE = 'In order to provide you with possible appointment times, please add items to your cart.'
export const ITEMS_LIMIT = 8
export const ITEMS_NEXT_DAY_THRESHOLD = 3
export const SELECTED_DAY_MESSAGE = 'Available appointment times for '
export const NEXT_DAY_MESSAGE_PREFIX = 'View '
export const NEXT_DAY_MESSAGE_SUFFIX = ' appointment times for the next available day, '
export const TIME_SLOTS_TABLE_ID = 'date-times-selector-times-table'
export const APPOINTMENT_DURATION_DISCLOSURE_TEXT = 'Appointment duration will be confirmed at check-in, based on your services.'
